import { type AssetDragItem, type BoardDragItem, DragType } from '~/components/Shared/Drag/dragTypes';

export const isAssetDragItem = (item: AssetDragItem | BoardDragItem): item is AssetDragItem =>
  item.type === DragType.asset || item.type === DragType.file;
